import React, { useState } from 'react';
import NavBarDesktop from './NavBarDesktop';
import NavBarMobile from './NavBarMobile';

export default function NavBar({ handleClick }) {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      <NavBarDesktop handleClick={handleClick} />
      <NavBarMobile
        handleClick={handleClick}
        showMenu={showMenu}
        setShowMenu={setShowMenu}
      />
    </>
  );
}
